import ModalLink from 'components/ModalLink'
import { memo } from 'react'
import { Content, RestrictedContent } from './style'
import { Box, Stack } from '@mui/material'
import { ReactComponent as IconBack } from './back.svg'
import { useNavigate } from 'react-router-dom'

export const RestrictedTermsView = memo(() => {
  const navigate = useNavigate()
  return (
    <ModalLink
      width="435px"
      isIn={true}
      hideCloseBtn={true}
      header={
        <Stack
          direction="row"
          alignItems={'center'}
          gap={1}
          onClick={() => {
            navigate('/restricted')
          }}
        >
          <IconBack />
          Terms of Use
        </Stack>
      }
    >
      <RestrictedContent>
        <Content>
          This website-hosted user interface (this “Interface”) is a frontend
          software portal to the ZKEX protocol, a decentralized and
          community-driven collection of blockchain-enabled smart contracts and
          tools (the “Protocol”). This Interface is made available by the ZKEX
          Corp., however all transactions conducted on the Protocol are run by
          permissionless and autonomous smart contracts. As the Interface the
          Protocol and its related smart contracts are accessible by any user,
          entity or third party, there may be a number of third-party web and
          mobile user-interfaces that allow for interaction with the Protocol.
          <p>
            YOUR USE OF THE INTERFACE AND PROTOCOL ARE ENTIRELY AT YOUR OWN
            RISK.
          </p>
        </Content>
      </RestrictedContent>
    </ModalLink>
  )
})
